import { RegistrationRequestTab } from '../api-refactored/group-exam-registration/usePostReviewGroupExamRegistration';
import { preferredAddressType, preferredContactType } from '../models';

export const fallbackEmptyObject = (obj: any) => obj || {};

export const fallbackNull = (obj: any) => obj || null;

export const trueToRender = (condition: boolean | undefined | null, component: React.ReactNode) =>
  condition ? component : null;

/**
 * Construct contact string to display.
 * If value of string array is empty then return '-'.
 * If 'withSign' is true, attach sign '+' in front of the string.
 *
 * @param withSign whether to attach sign '+' in front of the string
 * @param args string array
 */
export const getContactDisplayValue = (withSign: boolean, ...args: any[]): string => {
  let value = '';
  if (withSign) {
    value = '+';
  }
  const filteredArray = args.filter((e) => e);
  if (filteredArray.length > 0) {
    value += args.join(' ');
  } else {
    value = '-';
  }
  return value;
};

/**
 * Construct array of address to display.
 * Remove undefined/null/empty string.
 * If value of string array is empty then return '-'.
 *
 * @param args string array
 */
export const getAddressDisplayArray = (args: any[]): string[] => {
  const filteredArray = args.filter((e) => e);
  if (filteredArray.length <= 0) {
    return ['-'];
  }
  return args;
};

/**
 * Return 'L' if local address preferred. Else return 'F' representing foreign address.
 *
 * @param isPreferredLocalAddress indicator whether local address is preferred
 */
export const getPreferredAddress = (
  isPreferredLocalAddress: null | undefined | boolean
): preferredAddressType | undefined => {
  if (isPreferredLocalAddress === null || isPreferredLocalAddress === undefined) {
    return undefined;
  }

  return isPreferredLocalAddress ? 'L' : 'F';
};

/**
 * Return 'M' if mobile number preferred. Else return 'T' representing telephone number.
 *
 * @param isPreferredMobileNumber indicator whether mobile number is preferred
 */
export const getPreferredContactType = (
  isPreferredMobileNumber: null | undefined | boolean
): preferredContactType | undefined => {
  if (isPreferredMobileNumber === undefined || isPreferredMobileNumber === null) {
    return undefined;
  }

  return isPreferredMobileNumber ? 'M' : 'T';
};

/**
 * If compareAgainstValue & preferredContactValue is the same, return the 'preferred contact'
 * string. Else return empty string.
 *
 * @param compareAgainstValue preferred contact type to compared with
 * @param preferredContactValue target preferred contact type
 */
export const getIsPreferredContactText = (
  compareAgainstValue: preferredContactType,
  preferredContactValue?: preferredContactType
) => (preferredContactValue === compareAgainstValue ? 'Preferred Contact' : '');

/**
 * set tab of candidate or subject
 * @param selectedTab number
 * @param returns RegistrationRequestTab
 */
export const candidateOrSubjectListType = (selectedTab: number): RegistrationRequestTab => {
  switch (selectedTab) {
    case 0:
      return RegistrationRequestTab.CANDIDATE_LIST;
    case 1:
      return RegistrationRequestTab.SUBJECT_LIST;
    default:
      return RegistrationRequestTab.CANDIDATE_LIST;
  }
};
